import React from "react"

import { Link, Breadcrumbs as MuiBreadcrumbs, Typography } from "@mui/material"
import T from "prop-types"
import { and } from "ramda"
import { cx, mapIndexed as map } from "ramda-extension/es"

import { useStyles } from "./css"
import { Icon } from "../../atoms"

export const Breadcrumbs = ({ items }) => {
  const classes = useStyles()

  const renderItem = ({ customAction, isFirst, isLast, title, url, id }, index) => {
    return !isLast ? (
      <Link
        id={id}
        key={index}
        href={url}
        onClick={(event) => customAction && customAction(event)}
        classes={{ root: classes.link }}
        style={and(isFirst, { paddingTop: 1 })}
        underline="hover">
        {isFirst ? <Icon color="#756372" name="home" size={15} className={classes.icon} /> : title}
      </Link>
    ) : (
      <Typography classes={{ root: classes.current }} key={index}>
        {title}
      </Typography>
    )
  }

  const itemsWithoutSearch = items?.map(({url, ...other}) => {
    if (!url) return other

    const queryParams = new URLSearchParams(url.split("?")[1])
    queryParams.set("search", "")

    return {
      ...other,
      url: url.split("?")[0]
        + ("" && ("?" + queryParams.toString()) || "")
    }
  }) || items

  return (
    <div className={cx(classes.container, "breadcrumbs-container")}>
      <MuiBreadcrumbs
        aria-label="breadcrumb"
        component={"div"}
        classes={{ root: classes.root, separator: classes.separator }}>
        {items && map(renderItem, itemsWithoutSearch)}
      </MuiBreadcrumbs>
    </div>
  )
}

Breadcrumbs.propTypes = {
  items: T.array.isRequired,
}
